<div class="chart-container">
  <div class="score-tooltip-lineChart" [ngStyle]="{left: tooltipX + 'px', top: tooltipY + 'px', display: tooltipVisible}">
    <div class="tooltipHeading">{{tooltipHeading}}</div>
    <div class="tooltipData border-bottom" *ngIf="tooltipResponse != null && tooltipResponse !== ''">
      <div class="tooltipDataLabel">Responses</div>
      <div class="tooltipDataValue">{{tooltipResponse}}</div>
    </div>
    <div class="tooltipData padding-bottom" *ngIf="chartType != 'mutliSelect'">
      <div class="tooltipDataLabel">{{yText}}</div>
      <div class="tooltipDataValue">{{tooltipCount}}</div>
    </div>
    <ng-container *ngIf="chartType == 'mutliSelect'">
      <div class="tooltipData" *ngFor="let dataPoint of tooltipData; let last = last"  [ngClass]="{'border-bottom': !last, 'padding-bottom': last}">
        <div class="tooltipDataLabel"><span [innerHTML]=" dataPoint.label"></span></div>
        <div class="tooltipDataValue">{{dataPoint.count}}</div>
      </div>
    </ng-container>
  </div>
  <canvas #chartCanvas class="graph"></canvas>
    <!-- <app-tooltip [title]="tooltipTitle" [data]="tooltipValue" [tooltipId]="elementId"></app-tooltip> -->
</div>
